import { createFileRoute } from '@tanstack/react-router'
import { ResellerDidTransfersPage } from '@/features/reseller/pages/did-transfers'

export const Route = createFileRoute('/_authenticated/reseller/did-transfers')({
  component: ResellerDidTransfersPage,
})

